import { Star, Paperclip } from 'lucide-react';

export const fmtDate = (ms) => {
  const d = new Date(ms);
  const today = new Date();
  return d.toDateString() === today.toDateString()
    ? d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })
    : d.toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' });
};

export const ThreadList = ({ threads, selectedId, onSelect, onStar }) => {
  if (!threads.length) return <p className="p-8 text-center text-sm text-slate-500" data-testid="gmail-empty">Aucun e-mail</p>;
  return (
    <ul className="divide-y divide-slate-100" data-testid="gmail-thread-list">
      {threads.map((t) => (
        <li
          key={t.id}
          onClick={() => onSelect(t.id)}
          data-testid={`gmail-thread-${t.id}`}
          className={`px-4 py-3 cursor-pointer transition-colors hover:bg-slate-50 ${selectedId === t.id ? 'bg-blue-50' : ''} ${t.unread ? 'bg-white' : 'bg-slate-50/40'}`}
        >
          <div className="flex items-center gap-2">
            <button
              onClick={(e) => { e.stopPropagation(); onStar(t); }}
              data-testid={`gmail-star-${t.id}`}
              className="shrink-0"
            >
              <Star className={`h-4 w-4 ${t.starred ? 'fill-amber-400 text-amber-400' : 'text-slate-300'}`} />
            </button>
            <span className={`truncate text-sm ${t.unread ? 'font-bold text-slate-900' : 'text-slate-700'}`}>{t.from_name}</span>
            {t.count > 1 && <span className="text-xs text-slate-400">{t.count}</span>}
            <span className="ml-auto text-xs text-slate-500 shrink-0">{fmtDate(t.date)}</span>
          </div>
          <p className={`truncate text-sm mt-0.5 ${t.unread ? 'font-semibold text-slate-900' : 'text-slate-600'}`}>{t.subject}</p>
          <p className="truncate text-xs text-slate-500 mt-0.5">{t.snippet}</p>
        </li>
      ))}
    </ul>
  );
};

export const AttachIcon = Paperclip;
